import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: max-content;
    padding: 10px;
    display: flex;
    flex-direction: column;
`

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid black;
    width: max-content;
    margin-bottom: 2%;
    padding: 20px;
`

export const From = styled.div`
    margin-top: 3%;
`

export const TextDiv = styled.div`
    display: flex;

    p{
        margin-left: 5px;
    }
`

export const InputData = styled.div`
    width: 100%;
    height: 5vh;
    margin-top: 3%;

    button {
        margin-left: 1%;
    }

    span {
        margin-left: 4px;
    }
`

